import { FC } from "react";
import cls from "classnames";
import style from "./style.module.scss";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export interface LoaderProps {
  full?: boolean;
  className?: string;
}

const Loader: FC<LoaderProps> = ({ full, className }) => {
  return (
    <div className={cls(style.loader, full && style.loader_full, className)}>
      <Spin indicator={<LoadingOutlined spin />} />
    </div>
  );
};

export default Loader;
